import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../Styles/forms.css";

const PatientSymptomsForm = (props) => {
  const { initialValues, onSubmit, patientData } = props;
  const navigate = useNavigate();
  console.log(props);

  const patientSymptomsInfo = props.initialValues.patientSymptoms?.[0] || {};

  // const patientSymptomsInfo = Array.isArray(props.initialValues?.patientSymptoms)
  // ? props.initialValues.patientSymptoms[0]
  // : null;

console.log('patientSymptomsInfo', patientSymptomsInfo);

  const formInitialValues = {
    PATIENT_SYMPTOMS: patientSymptomsInfo?.PATIENT_SYMPTOMS || "",
    VISIT_DATE: patientSymptomsInfo?.VISIT_DATE ? patientSymptomsInfo.VISIT_DATE.substring(0, 10) : "",
    // Other fields can be added here based on your requirements
  };

  const validationSchema = Yup.object().shape({
    PATIENT_SYMPTOMS: Yup.string(),
//    VISIT_DATE: Yup.date(),
    // Add validations for other fields as needed
  });

  return (
    <div className="form-wrapper">
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          console.log(values);
          onSubmit(values);
          actions.setSubmitting(false);
        }}
      >
        <Form>
          <FormGroup>
            <label htmlFor="PATIENT_SYMPTOMS">Symptoms</label>
            <Field name="PATIENT_SYMPTOMS" as="textarea" className="form-control" />
            <ErrorMessage name="PATIENT_SYMPTOMS" component="div" className="invalid-feedback" />
          </FormGroup>
          <FormGroup>
            <label htmlFor="VISIT_DATE">Visit Date</label>
            <Field name="VISIT_DATE" type="date" className="form-control" />
            <ErrorMessage name="VISIT_DATE" component="div" className="invalid-feedback" />
          </FormGroup>
          <div className="form-buttons">
            <button type="button" className="btn-back" onClick={() => navigate(-1)}>Back</button>
            <button type="submit" className="btn-next">Next</button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default PatientSymptomsForm;
